<template>
    <v-card>
        <v-card-text>
            <v-tabs
                v-model="tabActive"
                slider-color="primary">
                <div class="justify-space-between align-center display-flex full-width">
                    <div>
                        <v-tab ripple>
                            <span class="headline text-capitalize">Revisions</span>
                        </v-tab>
                        <v-tab ripple>
                            <span class="headline text-capitalize">Radiographies</span>
                        </v-tab>
                    </div>
                    <div>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-chip v-on="on">
                                    <v-avatar left>
                                        <v-icon>mdi-calendar</v-icon>
                                    </v-avatar>
                                    {{selectedTreatment.intervention_date | shortDate}}
                                </v-chip>
                            </template>
                            <span>Date d'intervention</span>
                        </v-tooltip>
                    </div>
                </div>
                <v-tab-item>
                    <v-card-text v-if="tabActive === 0">
                        <v-form ref="revisionForm" lazy-validation>
                            <v-container v-if="selectedTreatment.revisions && selectedTreatment.revisions.length > 0" grid-list-md pt-0>
                                <v-data-table
                                    :headers="headers"
                                    :items="selectedTreatment.revisions"
                                    class="elevation-1"
                                    :pagination.sync="paginator">
                                    >
                                    <template v-slot:items="props">
                                        <td>{{ props.item.revision_at ? props.item.revision_at : props.item.created_at | shortDate }}</td>
                                        <td>
                                            <b>Revision : </b>{{ props.item.active ? 'Oui' : 'Non' }}
                                            <div v-if="props.item.active"><b>Type : </b>{{ getText(props.item.type) }}</div>
                                        </td>
                                        <td>{{ props.item.gestures.length ? props.item.gestures.map(gesture => gesture.name).join(', '): '' }}</td>
                                        <td>{{ props.item.causes.length ? props.item.causes.map(cause => cause.name).join(', '): '' }}</td>
                                    </template>
                                </v-data-table>
                            </v-container>
                            <v-container grid-list-md pt-0>
                                <h4>Ajouter :</h4>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-label>Révision</v-label>
                                        <v-radio-group v-model="active" row
                                                       :rules="activeFormRules"

                                                       validate-on-blur>
                                            <v-radio label="Oui" :value="true"></v-radio>
                                            <v-radio label="Non" :value="false"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                    <v-flex xs12>

                                        <v-menu v-model="showDatePicker"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                max-width="290px"
                                                min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="dateFormatted"
                                                    label="Date de la révision"
                                                    append-icon="event"
                                                    readonly
                                                    v-on="on"
                                                    :rules="[v => !!v || 'Le champs est requis']"
                                                    @blur="revision_at = parseDate(dateFormatted)"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="revision_at" no-title
                                                           locale="fr"
                                                           @input="showDatePicker = false"></v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs12 v-if="active">
                                        <v-select
                                            :value="type"
                                            :rules="[v => !!v || 'Le champs est requis']"
                                            :items="[
                                {text: getText('REVISION_INFECTION'), value: 'REVISION_INFECTION'},
                                {text: getText('REVISION_DESCELLEMENT'), value: 'REVISION_DESCELLEMENT'},
                                {text: getText('REVISION_INSTABILITY'), value: 'REVISION_INSTABILITY'},
                                {text: getText('REVISION_PAIN'), value: 'REVISION_PAIN'},
                                {text: getText('REVISION_RESURFACAGE'), value: 'REVISION_RESURFACAGE'},
                                {text: getText('REVISION_RAIDEUR'), value: 'REVISION_RAIDEUR'},
                                {text: getText('REVISION_MALTRACKING'), value: 'REVISION_MALTRACKING'},
                                {text: getText('REVISION_DEFAULT_AXE_HKA'), value: 'REVISION_DEFAULT_AXE_HKA'},
                            ]"
                                            @change="(value) => { setRevisionFormType(value) }"
                                            label="Type"
                                            required
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-select
                                            multiple
                                            :items="allCauses"
                                            item-value="id"
                                            item-text="name"
                                            v-model="gestures"
                                        ></v-select>
                                        <v-select
                                            multiple
                                            :items="allGestures"
                                            item-value="id"
                                            item-text="name"
                                            v-model="causes"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                </v-tab-item>
                <v-tab-item>
                    <v-card-text v-if="tabActive === 1">
                       <v-form ref="radiographForm"  lazy-validation>
                           <v-container v-if="selectedTreatment.radiographs && selectedTreatment.radiographs.length > 0" grid-list-md pt-0>
                               <v-data-table
                                   :headers="headersRadiograph"
                                   :items="selectedTreatment.radiographs"
                                   class="elevation-1"
                                   :pagination.sync="paginator">
                                   >
                                   <template v-slot:items="props">
                                       <td>{{ props.item.radiograph_at ? props.item.radiograph_at : props.item.created_at | shortDate }}</td>
                                       <td>{{ props.item.step ? getText(props.item.step) : '' }}</td>
                                        <td>{{ props.item.face_cfti ? getText('ARTHROSIS_' + props.item.face_cfti ) : ''}}</td>
                                        <td>{{ props.item.face_cfte ? getText('ARTHROSIS_' + props.item.face_cfte ) : ''}}</td>
                                        <td>{{ props.item.schuss_cfti ? getText('ARTHROSIS_' + props.item.schuss_cfti ) : ''}}</td>
                                        <td>{{ props.item.schuss_cfte ? getText('ARTHROSIS_' + props.item.schuss_cfte ): ''}}</td>
                                       <td>{{ props.item.profile_slope ? getText('SLOPE_BEFORE')+ ' ' + props.item.profile_slope +'°' : '' }}</td>
                                        <td>{{ patellaHeightLabel(props.item.profile_patella_h)}}</td>
                                        <td>{{ props.item.axial_cfp ? getText('ARTHROSIS_' + props.item.axial_cfp ) : ''}}</td>
                                        <td>{{ props.item.axial_hka ? getText('HKA_ANGLE') + props.item.axial_hka + '°': ''}}</td>
                                        <td>{{ props.item.axial_ldfa ? getText('LDFA_ANGLE') + props.item.axial_ldfa + '°': ''}}</td>
                                        <td>{{ props.item.axial_mpta ? getText('MPTA_ANGLE') + props.item.axial_mpta + '°': ''}}</td>
                                   </template>
                               </v-data-table>
                           </v-container>
                           <v-container grid-list-md pt-0>
                               <h4>Ajouter :</h4>
                               <v-layout wrap>
                                   <v-flex xs12>
                                       <v-label>Radiographie</v-label>
                                       <v-radio-group v-model="step" row
                                                      :rules="stepFormRules"
                                                      validate-on-blur>
                                           <v-radio label="Pré-opératoire" value="pre"></v-radio>
                                           <v-radio label="Post-opératoire" value="post"></v-radio>
                                       </v-radio-group>
                                   </v-flex>
                                   <v-flex xs12>
                                       <v-menu v-model="showDatePicker"
                                               :close-on-content-click="false"
                                               transition="scale-transition"
                                               offset-y
                                               full-width
                                               max-width="290px"
                                               min-width="290px">
                                           <template v-slot:activator="{ on }">
                                               <v-text-field
                                                   v-model="dateFormatted"
                                                   label="Date de la radiographie"
                                                   append-icon="event"
                                                   readonly
                                                   v-on="on"
                                                   :rules="[v => !!v || 'Le champs est requis']"
                                                   @blur="radiograph_at = parseDate(dateFormatted)"
                                               ></v-text-field>
                                           </template>
                                           <v-date-picker v-model="radiograph_at" no-title
                                                          locale="fr"
                                                          @input="showDatePicker = false"></v-date-picker>
                                       </v-menu>
                                   </v-flex>
                                   <v-flex xs12>
                                       <span>Rx Genou Face (en charge)</span>
                                       <v-select
                                           :value="face_cfti"
                                           :items="arthrosisLabels()"
                                           @change="(value) => { setRadiographFormFaceCfti(value) }"
                                           label="CFTI - arthrose stade"
                                           required
                                       ></v-select>
                                       <v-select
                                           :value="face_cfte"
                                           :items="arthrosisLabels()"
                                           @change="(value) => { setRadiographFormFaceCfte(value) }"
                                           label="CFTE - arthrose stade"
                                           required
                                       ></v-select>
                                   </v-flex>
                                   <v-flex xs12 v-if="isStepPre">
                                       <span>Rx Genou Schuss (en charge)</span>
                                       <v-select
                                           :value="schuss_cfti"
                                           :items="arthrosisLabels()"
                                           @change="(value) => { setRadiographFormSchussCfti(value) }"
                                           label="CFTI - arthrose stade"
                                           required
                                       ></v-select>
                                       <v-select
                                           :value="schuss_cfte"
                                           :items="arthrosisLabels()"
                                           @change="(value) => { setRadiographFormSchussCfte(value) }"
                                           label="CFTE - arthrose stade"
                                           required
                                       ></v-select>
                                   </v-flex>
                                   <v-flex xs12>
                                       <span>Rx Genou Profil</span>
                                       <v-select
                                           :value="profile_slope"
                                           :items="kneeProfileSlopeOptions()"
                                           @change="(value) => { setRadiographFormProfileSlope(value) }"
                                           label="Pente tibiale"
                                           required
                                       ></v-select>
                                       <v-select
                                           :value="profile_patella_h"
                                           :items="[
                                               {text: '<0.6mm (patella Baja)', value: '<0.6'},
                                               {text: 'Entre 0.6 et 1.3mm (hauteur normale)', value: '0.6-1.2'},
                                               {text: '>1.3mm (patella Alta)', value: '>1.3'},
                                           ]"
                                           @change="(value) => { setRadiographFormProfilePatellaH(value) }"
                                           label="Hauteur rotule (Caton Deschamps)"
                                           required
                                       ></v-select>
                                   </v-flex>
                                   <v-flex xs12>
                                       <span>Rx axiale rotule</span>
                                       <v-select
                                           :value="axial_cfp"
                                           :items="arthrosisLabels()"
                                           @change="(value) => { setRadiographFormAxialCfp(value) }"
                                           label="CFP - arthrose stade"
                                           required
                                       ></v-select>
                                   </v-flex>
                                   <v-flex xs12>
                                       <span>Rx Longs axes (EOS) en charge</span>
                                       <v-select
                                           :value="axial_hka"
                                           :items="longAxialOptions('HKA')"
                                           @change="(value) => { setRadiographFormAxialHka(value) }"
                                           label="HKA"
                                           required
                                       ></v-select>
                                       <v-select
                                           :value="axial_ldfa"
                                           :items="longAxialOptions('LDFA')"
                                           @change="(value) => { setRadiographFormAxialLdfa(value) }"
                                           label="LDFA"
                                           required
                                       ></v-select>
                                       <v-select
                                           :value="axial_mpta"
                                           :items="longAxialOptions('MPTA')"
                                           @change="(value) => { setRadiographFormAxialMpta(value) }"
                                           label="MPTA"
                                           required
                                       ></v-select>
                                   </v-flex>
                               </v-layout>
                           </v-container>
                       </v-form>
                    </v-card-text>
                </v-tab-item>
            </v-tabs>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="close">Annuler</v-btn>
            <v-btn color="primary" @click="save">Enregistrer</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex'
import {getTranslationString} from "../../../helper";
import {stringify} from "mocha/lib/utils";
import props from "vuetify/lib/components/VCalendar/util/props";
    export default {
        name: "RevisionForm",
        data() {
            return {
                showDatePicker: false,
                dateFormatted: '',
                tabActive: 0,
                headersRadiograph: [
                    {text: 'Date', value: 'radiograph_at'},
                    {text: 'Étape', value: 'step'},
                    {text: 'Genou Face (CFTI)', value: 'face_cfti'},
                    {text: 'Genou Face (CFTE)', value: 'face_cfte'},
                    {text: 'Genou Schuss (CFTI)', value: 'schuss_cfti'},
                    {text: 'Genou Schuss (CFTE)', value: 'schuss_cfte'},
                    {text: 'Genou Profil (Pente tibiale)', value: 'profile_slope'},
                    {text: 'Genou Profil (Hauteur rotule)', value: 'profile_patella_h'},
                    {text: 'Axiale rotule (CFP)', value: 'axial_cfp'},
                    {text: 'Longs axes (HKA)', value: 'axial_hka'},
                    {text: 'Longs axes (LDFA)', value: 'axial_ldfa'},
                    {text: 'Longs axes (MPTA)', value: 'axial_mpta'},
                ],

                headers: [
                    {text: 'Date', value: 'revision_at'},
                    {text: 'Révision', value: 'active'},
                    {text: 'Gestes', value: 'gestures'},
                    {text: 'Causes', value: 'causes'},
                ],
                paginatorText: "Résultats par page",
                paginator: {
                    rowsPerPage: 5,
                    sortBy: 'revision_at',
                    descending:true
                }
            }
        },
        computed: {
            props() {
                return props
            },
            ...mapState('treatments', {
                selectedTreatment: state => state.selectedTreatment,
                allGestures: state => state.gestures,
                allCauses: state => state.causes,
            }),
            isStepPre() {
                return this.step === 'pre'
            },
            activeFormRules() {
                return [
                    ((this.active === false) || (this.active && this.type !== null))
                    || "Merci de sélectionner au moins une valeur"
                ];
            },
            active: {
                get() {
                    return this.$store.state.treatments.revisionForm.active
                },
                set(value) {
                    this.setRevisionFormActive(value)
                }
            },
            type: {
                get() {
                    return this.$store.state.treatments.revisionForm.type
                },
                set(value) {
                    this.setRevisionFormType(value)
                }
            },
            revision_at: {
                get() {
                    return this.$store.state.treatments.revisionForm.revision_at
                },
                set(value) {
                    this.setRevisionFormDate(value)
                }
            },
            causes: {
                get() {
                    return this.$store.state.treatments.revisionForm.causes
                },
                set(value) {
                    this.setRevisionCauses(value)
                }
            },
            gestures: {
                get() {
                    return this.$store.state.treatments.revisionForm.gestures
                },
                set(value) {
                    this.setRevisionsGestures(value)
                }
            },
            stepFormRules() {
                return [
                    // ((this.step === 'pre') || (this.step === 'post'))
                    // || "Merci de sélectionner au moins une valeur"
                ];
            },
            step: {
                get() {
                    return this.$store.state.treatments.radiographForm.step
                },
                set(value) {
                    this.setRadiographFormStep(value)
                }
            },
            radiograph_at: {
                get() {
                    return this.$store.state.treatments.radiographForm.radiograph_at
                },
                set(value) {
                    this.setRadiographFormDate(value)
                }
            },
            face_cfti: {
                get() {
                    return this.$store.state.treatments.radiographForm.face_cfti
                },
                set(value) {
                    this.setRadiographFormFaceCfti(value)
                }
            },
            face_cfte: {
                get() {
                    return this.$store.state.treatments.radiographForm.face_cfte
                },
                set(value) {
                    this.setRadiographFormFaceCfte(value)
                }
            },
            schuss_cfti: {
                get() {
                    return this.$store.state.treatments.radiographForm.schuss_cfti
                },
                set(value) {
                    this.setRadiographFormSchussCfti(value)
                }
            },
            schuss_cfte: {
                get() {
                    return this.$store.state.treatments.radiographForm.schuss_cfte
                },
                set(value) {
                    this.setRadiographFormSchussCfte(value)
                }
            },
            profile_slope: {
                get() {
                    return this.$store.state.treatments.radiographForm.profile_slope
                },
                set(value) {
                    this.setRadiographFormProfileSlope(value)
                }
            },
            profile_patella_h: {
                get() {
                    return this.$store.state.treatments.radiographForm.profile_patella_h
                },
                set(value) {
                    this.setRadiographFormProfilePatellaH(value)
                }
            },
            axial_cfp: {
                get() {
                    return this.$store.state.treatments.radiographForm.axial_cfp
                },
                set(value) {
                    this.setRadiographFormAxialCfp(value)
                }
            },
            axial_hka: {
                get() {
                    return this.$store.state.treatments.radiographForm.axial_hka
                },
                set(value) {
                    this.setRadiographFormAxialHka(value)
                }
            },
            axial_ldfa: {
                get() {
                    return this.$store.state.treatments.radiographForm.axial_ldfa
                },
                set(value) {
                    this.setRadiographFormAxialLdfa(value)
                }
            },
            axial_mpta: {
                get() {
                    return this.$store.state.treatments.radiographForm.axial_mpta
                },
                set(value) {
                    this.setRadiographFormAxialMpta(value)
                }
            },



        },
        methods: {
            patellaHeightLabel(value) {
                switch (value) {
                    case '<0.6':
                        return '<0.6mm (patella Baja)'
                    case '0.6-1.2':
                        return 'Entre 0.6 et 1.3mm (hauteur normale)'
                    case '>1.3':
                        return '>1.3mm (patella Alta)'
                    default:
                        return ''
                }
            },
            longAxialOptions(type) {
                const longAxialOptions = [
                    {
                        text: this.getText(type + '_ANGLE')+' < -15°',
                        value: '<-15'
                    }
                ];

                for (let i = -15; i <= 15; i++) {
                    const text = i < 0 ? ` ${i}° (Valgus)` : ` ${i}° (Varus)`;
                    longAxialOptions.push({
                        text: this.getText(type + '_ANGLE') + text,
                        value: stringify(i)
                    });
                }

                longAxialOptions.push({
                    text: this.getText(type + '_ANGLE') +' >15°',
                    value: '>15'
                });

                return longAxialOptions;
            },
            kneeProfileSlopeOptions() {
                const kneeProfileOptions = [];
                for (let i = 0; i < 13; i++) {
                    kneeProfileOptions.push({
                        text: this.getText('SLOPE_BEFORE')+ ' ' + i +'°',
                        value: stringify(i)
                    })
                }
                kneeProfileOptions.push({
                    text: this.getText('SLOPE_BEFORE') + ' >' + 12 +'°',
                    value: '>12'
                })
                return kneeProfileOptions;
            },
            arthrosisLabels() {
                const arthrosisLabels = [];
                for (let i = 0; i < 5; i++) {
                    arthrosisLabels.push({
                        text: this.getText('ARTHROSIS_' + i),
                        value: i
                    })
                }
                return arthrosisLabels;
            },
            save() {
                if(this.tabActive === 0) {
                    this.saveRevision()
                } else {
                    this.saveRadiograph()
                }
            },
            saveRevision(){
                if (this.$refs.revisionForm.validate()) {
                    this.createRevision().then(response => {
                        this.getTreatmentInfo()
                        this.initRevisionForm()
                        this.setShowRevisionForm(false);
                    }).catch(reason => {
                        //Stay here..
                    })
                }
            },
            saveRadiograph() {
                if (this.$refs.radiographForm.validate()) {
                    this.createRadiograph().then(response => {
                        this.getTreatmentInfo()
                        this.initRadiographForm()
                        this.setShowRevisionForm(false);
                    }).catch(reason => {
                        //Stay here..
                    })
                }
            },
            close() {
                this.setShowRevisionForm(false)
            },
            getText(key) {
                return getTranslationString(key)
            },
            parseDate (date) {
                if (!date) return null

                const [day, month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            ...mapMutations('treatments', {
                initRevisionForm: 'initRevisionForm',
                initRadiographForm: 'initRadiographForm',
                setRevisionFormActive: 'setRevisionFormActive',
                setRevisionFormType: 'setRevisionFormType',
                setRevisionFormDate: 'setRevisionFormDate',
                setRevisionsGestures: 'setRevisionGestures',
                setRevisionCauses: 'setRevisionCauses',
                setShowRevisionForm: 'setShowRevisionForm',
                setRadiographFormStep: 'setRadiographFormStep',
                setRadiographFormDate: 'setRadiographFormDate',
                setRadiographFormFaceCfti: 'setRadiographFormFaceCfti',
                setRadiographFormFaceCfte: 'setRadiographFormFaceCfte',
                setRadiographFormSchussCfti: 'setRadiographFormSchussCfti',
                setRadiographFormSchussCfte: 'setRadiographFormSchussCfte',
                setRadiographFormProfileSlope: 'setRadiographFormProfileSlope',
                setRadiographFormProfilePatellaH: 'setRadiographFormProfilePatellaH',
                setRadiographFormAxialCfp: 'setRadiographFormAxialCfp',
                setRadiographFormAxialHka: 'setRadiographFormAxialHka',
                setRadiographFormAxialLdfa: 'setRadiographFormAxialLdfa',
                setRadiographFormAxialMpta: 'setRadiographFormAxialMpta',
            }),
            ...mapActions('treatments', ['getTreatmentInfo', 'createRevision', 'createRadiograph']),
            ...mapActions('medical_cases', ['getMedicalCaseInfo'])
        },
        watch: {
            revision_at(date) {
                this.dateFormatted = date ? this.$options.filters.formatedDate(date) : ''
            },
            radiograph_at(date) {
                this.dateFormatted = date ? this.$options.filters.formatedDate(date) : ''
            }
        }
    }
</script>
